import React, { useEffect } from 'react';
import { isMobile } from 'react-device-detect';
import { connect } from 'react-redux';
import EpiContext from '@episerver/spa-core/Spa';
import { OwnershipTransferStep, EquipmentPaymentObligation, FormSendType } from './Constant/Constant';
import {
  setCurrentStep,
  setShowPopUp,
  saveToHistory,
  resetState,
  fetchExistingRequests,
  addOwnershipTransferRequest,
  setIsJetConnection,
} from './OwnershipTransferSlice';
import loginSubTypes from '../../../constans/loginSubTypes';
import { showAppLoader, hideAppLoader } from '../../Shared/Loader/LoaderSlice';
import { getContactCompanyList } from '../PortalsBlock/portalSlice';
import SelectCompany from '../../Shared/SelectBusinessCompany/SelectCompany';
import Dashboard from './Dashboard/Dashboard';
import SelectActionType from './Steps/SelectActionType';
import ContactPersonForm from './Steps/ContactPersonForm';
import CustomerForm from './Steps/CustomerForm';
import UploadFile from './Steps/UploadFile';
import GeneralMessage from './Steps/GeneralMessage';
import ValidateCustomer from './Steps/ValidateCustomer';
import Obligations from './Steps/Obligations';
import FutureAccountType from './Steps/FutureAccountType';
import BanSelecting from './Steps/BanSelecting';
import Config from '../../../Config';
import SuccessPage from './Steps/SuccessPage';
import SuccessPageBulkRequest from './Steps/BulkSuccessPage';
import BulkRequestErrorPage from './Steps/BulkRequestErrorPage'
import {transferOption} from "app/Components/Block/TransferOrganizationAccountBlock/Constant/Constant";


const OwnershipTransferContactPersonMain = (props) => {

  const generalMessageActions = {
    goToDashboard: () => props.setCurrentStep(OwnershipTransferStep.Dashboard),
    businessLobby: () => EpiContext.navigateTo(Config.businessLobbyUrl),
    nextStepSuccessPage: () => nextStepSuccessPage(),
  };

  const getSelectCompanyNextStep = (org) => {

    if (isMobile) {
      props.setCurrentStep(OwnershipTransferStep.SelectActionType);
    }
    else {
      props.fetchExistingRequests(org)
    }
  }

  async function nextStepSuccessPage() {
    await props.resetState();
    if (props.authentication?.loginData.userDetails?.Impersonate && props.authentication?.loginData.userDetails?.loginSubType == loginSubTypes.ONBEHALF) {
      props.setIsJetConnection(true)
    }
    getSelectCompanyNextStep(props.portalsBlock.selectedHetPayId);
  }

  let currentStep = () => {
    switch (props.data.currentStep) {
      case OwnershipTransferStep.SelectCompany:
        return (
          <div className='stepContainer'>
            <SelectCompany setNextStep={(org) => getSelectCompanyNextStep(org)} title='העברת בעלות ופיצול' />
          </div>
        );
      case OwnershipTransferStep.Dashboard:
        return <Dashboard />;
      case OwnershipTransferStep.SelectActionType:
        return <SelectActionType />;
      case OwnershipTransferStep.ValidateCustomer:
        return <ValidateCustomer />;
      case OwnershipTransferStep.FutureAccountType:
        return <FutureAccountType />;
      case OwnershipTransferStep.BanSelecting:
        return <BanSelecting />;
      case OwnershipTransferStep.EquipmentObligations:
        return <Obligations />;
      case OwnershipTransferStep.CustomerForm:
        return <CustomerForm submitRequest={submitRequest} />;
      case OwnershipTransferStep.UploadFile:
        return <UploadFile />;
      case OwnershipTransferStep.ContactPersonForm:
        return <ContactPersonForm submitRequest={submitRequest} />;
      case OwnershipTransferStep.SuccessPage:
        return <SuccessPage nextStepSuccessPage={nextStepSuccessPage} resendForms={false} resendML={false} />;
      case OwnershipTransferStep.ResendSuccessPage:
        return <SuccessPage nextStepSuccessPage={nextStepSuccessPage} goToLobby={() => generalMessageActions.businessLobby} resendForms={true} />;
      case OwnershipTransferStep.ResendMLSuccessPage:
        return <SuccessPage nextStepSuccessPage={nextStepSuccessPage} goToLobby={() => generalMessageActions.businessLobby} resendML={true} />;
      case OwnershipTransferStep.SuccessPageBulkRequest:
        return <SuccessPageBulkRequest nextStepSuccessPage={nextStepSuccessPage} />
      case OwnershipTransferStep.ErrorPageBulkRequest:
        return <BulkRequestErrorPage />
      case OwnershipTransferStep.GeneralMessage:
        return (
          <GeneralMessage
            messageData={props.data.generalMessage}
            buttonClick={generalMessageActions[props.data.generalMessage?.buttonClick]}
            secondButtonClick={generalMessageActions[props.data.generalMessage?.secondButtonClick]}
            data={props.data}
            isNewLineAction={props.data.selectedTransferOption === transferOption.newLine}
          />
        );
      default:
        break;
    }
  };



  function submitRequest() {
    const data = {
      subscriberPhoneNumber: props.data.selectedPhoneNumber,
      subscriberFirstName: props.data.subscriberPersonalData.firstName,
      subscriberLastName: props.data.subscriberPersonalData.lastName,
      subscriberIdNumber: props.data.subscriberPersonalData.idNumber,
      subscriberCityName: props.data.subscriberAddress.city,
      subscriberStreetName: props.data.subscriberAddress.street,
      subscriberHouseNum: props.data.subscriberAddress.houseNum,
      subscriberZipCode: props.data.subscriberAddress.zipCode,
      orgId: props.portalsBlock.selectedHetPayId,
      hetPayNumber: props.portalsBlock.selectedHetPay,
      orgName: props.portalsBlock.selectedOrgName,
      contactPersonFormMethod: props.data.contactPersonSendFormType.type,
      contactPersonFormMethodValue:
        props.data.contactPersonSendFormType.type == FormSendType.sms
          ? props.data.contactPersonSendFormType.sms
          : props.data.contactPersonSendFormType.email,
      subscriberFormMethod: props.data.subscriberSendFormType.type,
      subscriberFormMethodValue:
        props.data.subscriberSendFormType.type == FormSendType.sms
          ? props.data.subscriberSendFormType.sms
          : props.data.subscriberSendFormType.email,
      selectedBan: props.data.selectedBan,
      actionType: props.data.selectedActionType,
      equipmentObligations: getEquipmentObligationsValue(),
      futureAccountType: props.data.futureAccountType,
    };
    props.addOwnershipTransferRequest(data);
  }

  function getEquipmentObligationsValue() {
    if (props.data.currentEquipmentObligations?.length > 0) {
      if (props.data.responsibleForNextPayments === EquipmentPaymentObligation.Customer) {
        return 1;
      } else {
        return 2;
      }
    }
    return 0;
  }

  return <>{currentStep()}</>;
};

const mapStateToProps = (state) => ({
  data: state.OwnershipTransfer,
  portalsBlock: state.portalsBlock,
  authentication: state.authentication,
});

const mapDispatchToProps = {
  setShowPopUp,
  setCurrentStep,
  saveToHistory,
  getContactCompanyList,
  showAppLoader,
  hideAppLoader,
  resetState,
  fetchExistingRequests,
  addOwnershipTransferRequest,
  setIsJetConnection,
};

export default connect(mapStateToProps, mapDispatchToProps)(OwnershipTransferContactPersonMain);
